module.exports = __webpack_public_path__ + "static/media/Project1_Fig9.620cc0c9.svg";